import React from 'react'
import ReactRecaptcha from 'react-recaptcha'

const Recaptcha = ({ input, inputRef }) => (
  <ReactRecaptcha
    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
    render='explicit'
    verifyCallback={input.onChange}
    ref={inputRef}
  />
)

export default Recaptcha



// WEBPACK FOOTER //
// ./src/components/Recaptcha/index.js